<div
  class="dialog-alert"
  fxLayout="column"
  fxLayoutAlign="start center"
  fxLayoutGap="30px"
>
  <button
    class="dialog-alert-close"
   mat-dialog-close
    fxFlexAlign="end"
    type="button"
    mat-icon-button
  >
    <mat-icon>close</mat-icon>
  </button>

  <h3 class="rm-margin">{{"ENTER_NEW_PHONE_NUMBER" | translate}}</h3>

  <form
  [formGroup]="phoneNumberForm"
  (ngSubmit)="sendSms()"
  class="phone"
  fxLayout="column"
  fxLayoutAlign="start center"
>
  <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="20px">
    <mat-form-field appearance="outline">
      <mat-label>{{ "PHONE_CODE" | translate }}</mat-label>
      <mat-select
        formControlName="phoneCode"
        name="phoneCode"
      >
        <mat-option *ngFor="let phone of phoneCodes" [value]="phone?.code">
          <img
            class="border-1"
            width="16"
            height="12"
            [src]="'assets/flagssvg/' + phone?.slug + '.svg'"
            alt=""
          />
          {{ phone?.code }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ "PHONE_NUMBER" | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'PHONE_NUMBER' | translate"
        formControlName="phoneNumber"
      />
      <mat-icon matPrefix svgIcon="phone"></mat-icon>
    </mat-form-field>
  </div>

  <button
    type="submit"
    mat-flat-button
    class="my-button"
    color="primary"
    (click)="sendSms()"
  >
    <span>
      {{ "SEND_CODE" | translate }}
    </span>
  </button>
</form>

<ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{ length: 6, allowNumbersOnly: true }"></ng-otp-input>



</div>

<div id="recaptcha-container"></div>



